import React from "react";
import { FiUpload, FiFolder, FiSettings, FiLink, FiDownload } from "react-icons/fi";

const GroupDetailHeader = ({
  groupData,
  isMainAdmin,
  canUpload,
  displayedPhotos,
  uploading,
  handleUpload,
  handleShowCode,
  handleDownloadAll,
  navigate,
  id,
}) => {
  return (
    <>
      {/* QuickPhoto Reference Sub-Header (Title Left, Icons Right) */}
      <div className="quickphoto-album-subheader">
        <div className="quickphoto-subheader-left">
          <h1 className="quickphoto-center-title">{groupData.name}</h1>
        </div>

        <div className="quickphoto-subheader-right">
          <div className="quickphoto-action-icons-row">
            {canUpload && (
              <>
                <label
                  className="quickphoto-action-tile"
                  title="Upload Photos"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      e.currentTarget
                        .querySelector('input[type="file"]')
                        ?.click();
                    }
                  }}
                >
                  <input
                    type="file"
                    multiple
                    hidden
                    onChange={handleUpload}
                    disabled={uploading}
                  />
                  <span className="tile-icon"><FiUpload size={20} strokeWidth={2} /></span>
                </label>
                <label
                  className="quickphoto-action-tile"
                  title="Upload Folder"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      e.currentTarget
                        .querySelector('input[type="file"]')
                        ?.click();
                    }
                  }}
                >
                  <input
                    type="file"
                    webkitdirectory="true"
                    directory="true"
                    multiple
                    hidden
                    onChange={handleUpload}
                    disabled={uploading}
                  />
                  <span className="tile-icon"><FiFolder size={20} strokeWidth={2} /></span>
                </label>
              </>
            )}
            {isMainAdmin && (
                <button
                  className="quickphoto-action-tile"
                  onClick={() => navigate(`/group-settings/${id}`)}
                  title="Group Settings"
                >
                  <span className="tile-icon"><FiSettings size={20} strokeWidth={2} /></span>
                </button>
            )}
            <button
              className="quickphoto-action-tile"
              onClick={handleShowCode}
              title="Share"
            >
              <span className="tile-icon"><FiLink size={20} strokeWidth={2} /></span>
            </button>
            <button
              className="quickphoto-action-tile"
              onClick={handleDownloadAll}
              disabled={!displayedPhotos.length}
              title="Download All Photos"
            >
              <span className="tile-icon"><FiDownload size={20} strokeWidth={2} /></span>
            </button>
          </div>
        </div>
      </div>
      <div className="quickphoto-divider-line"></div>
    </>
  );
};

export default GroupDetailHeader;
